<div class="modal-header">
  <h2 mat-dialog-title [innerHTML]="data.title"></h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button" (click)="confirm()">{{data.confirmText}}</button>
</mat-dialog-actions>
